export default __webpack_public_path__ + "static/recyclable_animation-d96923f07b94258cc4e8ac0831fa9645.gif";